import { Link } from 'react-router-dom';
import { platforms } from '@/mocks/data';

const platformImages: Record<string, string> = {
  'r18-logo': 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20tech%20brand%20logo%20design%20with%20warm%20golden%20accents%20on%20clean%20neutral%20background%2C%20professional%20and%20premium%20feel%2C%20simple%20geometric%20shapes%2C%20sleek%20corporate%20identity&width=120&height=120&seq=r18-logo&orientation=squarish',
  'fanza-logo': 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20tech%20brand%20logo%20design%20with%20warm%20amber%20accents%20on%20clean%20neutral%20background%2C%20professional%20and%20premium%20feel%2C%20simple%20geometric%20shapes%2C%20sleek%20corporate%20identity&width=120&height=120&seq=fanza-logo&orientation=squarish',
};

export default function FeaturedPlatforms() {
  const featured = platforms.filter((p) => p.featured);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20" aria-labelledby="featured-title">
      <div className="text-center mb-10">
        <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 rounded-full text-xs font-medium mb-3">
          精选推荐
        </span>
        <h2 id="featured-title" className="font-heading text-xl md:text-2xl font-semibold text-foreground-900">
          <a href="#featured-title">推荐正版平台</a>
        </h2>
        <p className="text-sm text-foreground-600 mt-2 max-w-lg mx-auto">
          经过严格筛选的正版授权亚洲无码内容平台，确保内容合法、支付安全、隐私有保障。
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {featured.map((platform) => (
          <Link
            key={platform.id}
            to={`/article/${platform.slug}`}
            className="group bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 hover:border-primary-300/50 transition-all duration-300"
          >
            <div className="flex items-start gap-4">
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-xl bg-background-100 flex items-center justify-center flex-shrink-0 overflow-hidden">
                <img
                  src={platformImages[platform.logoSeq] || platformImages['r18-logo']}
                  alt={platform.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-heading font-semibold text-base text-foreground-900 group-hover:text-primary-600 transition-colors">
                    {platform.name}
                  </h3>
                  {platform.verified && (
                    <span className="w-4 h-4 flex items-center justify-center text-primary-500" title="已验证正版平台">
                      <i className="ri-verified-badge-fill text-sm"></i>
                    </span>
                  )}
                </div>
                <div className="flex items-center gap-1 mb-2">
                  <span className="w-3.5 h-3.5 flex items-center justify-center text-accent-500">
                    <i className="ri-star-fill text-xs"></i>
                  </span>
                  <span className="text-sm font-medium text-foreground-800">{platform.rating}</span>
                  <span className="text-xs text-foreground-500">({platform.reviewCount.toLocaleString()}条评价)</span>
                </div>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                  {platform.description}
                </p>
                <div className="flex flex-wrap gap-1.5">
                  {platform.features.slice(0, 3).map((feat) => (
                    <span
                      key={feat}
                      className="px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded-md text-xs whitespace-nowrap"
                    >
                      {feat}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>

      <div className="text-center mt-8">
        <Link
          to="/category/japan-uncensored"
          className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
        >
          查看全部正版平台
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </span>
        </Link>
      </div>
    </section>
  );
}